import * as React from 'react';
import { ActionButton, ButtonContainer, Main, MainBody, TextOverflowWrapper, Wrapper, } from './RegionPickerPrompt.styles';
import AutodeskBranding from '@innovyze/stylovyze/lib/components/LoginWrapper/AutodeskBranding';
import { Info360LogoIllustration } from '../../illustrations';
import { LoadingPage } from '../index';
import MainFooter from '@innovyze/stylovyze/lib/components/LoginWrapper/MainFooter';
import { Region } from '@innovyze/stylovyze/lib/types/regionPicker.types';
import { StyledForm } from '../LoginDomainPrompt/LoginDomainPrompt.styles';
import { selectRegionPicker } from '@innovyze/stylovyze/lib/selectors/regionPicker.selectors';
import { shouldUseRegionPicker } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import { useGlobalization } from '../../contexts/GlobalizationProvider/useGlobalization';
import { useSelector } from 'react-redux';
import { useRedirectAppName } from './useRedirectAppName';
export const RegionPickerButtons = ({ forceRegions, }) => {
    const { t } = useGlobalization();
    const { initialized, regions } = useSelector(selectRegionPicker);
    const { appTLD } = useRedirectAppName();
    const pickedRegions = forceRegions ?? regions;
    const getButtonsByRegion = () => {
        return (React.createElement(React.Fragment, null,
            pickedRegions.includes(Region.US) && (React.createElement(ActionButton, { dataCy: "select-us-region", color: "primary", onClick: () => {
                    localStorage.removeItem(shouldUseRegionPicker);
                    window.location.assign('/');
                } }, t('US'))),
            pickedRegions.includes(Region.EU) && (React.createElement(ActionButton, { dataCy: "select-eu-region", color: "primary", onClick: () => {
                    localStorage.removeItem(shouldUseRegionPicker);
                    window.location.assign(`https://${appTLD}.info360-eu.com/forge/login`);
                } }, t('EU'))),
            pickedRegions.includes(Region.AP) && (React.createElement(ActionButton, { dataCy: "select-ap-region", color: "primary", onClick: () => {
                    localStorage.removeItem(shouldUseRegionPicker);
                    window.location.assign(`https://${appTLD}.info360-ap.com/forge/login`);
                } }, t('AP')))));
    };
    return (React.createElement(Wrapper, { "data-cy": "region-picker" },
        React.createElement(Main, null,
            React.createElement(MainBody, null, React.createElement(StyledForm, null,
                React.createElement(Info360LogoIllustration, { color: "#000" }),
                React.createElement(TextOverflowWrapper, null, "Please select a region below:"),
                React.createElement(ButtonContainer, null, initialized ? (getButtonsByRegion()) : (React.createElement(LoadingPage, { size: "sm" }))))),
            React.createElement(MainFooter, null)),
        React.createElement(AutodeskBranding, null)));
};
